import { PurchasingLabelTemplateDTO } from "@/dto/template/PurchasingLabelTemplateDTO";
import { getPurchasingLabelTemplateList } from "@/services/api/moreFeatures/purchasingLabel/purchasingLabelTemplate";
import { useRequest } from "ahooks";
import { Select, SelectProps } from "antd";
import React, { useEffect } from "react";

interface PurchasingLabelTemplateSelectProps extends SelectProps<number> {
    onLoad?(templates: PurchasingLabelTemplateDTO[]): void;
    onChange?;
}

export const DEFAULT_PURCHASING_LABEL_TEMPLATE = "__DEFAULT_PURCHASING_LABEL_TEMPLATE__";

const PurchasingLabelTemplateSelect: React.FC<PurchasingLabelTemplateSelectProps> = function (props) {
    const { onLoad, ...otherProps } = props;
    const { loading, data: templates } = useRequest(getPurchasingLabelTemplateList);

    useEffect(() => {
        onLoad?.(templates);

        if (templates?.length) {
            const cacheTemplateId = localStorage.getItem(DEFAULT_PURCHASING_LABEL_TEMPLATE);

            if (cacheTemplateId) {
                const cacheTemplate = templates.find((it) => it.id === Number(cacheTemplateId));

                if (cacheTemplate) {
                    props.onChange?.(Number(cacheTemplateId));

                    return;
                }
            }

            props.onChange?.(templates[0].id);
        }
    }, [templates]);

    return (
        <Select
            loading={loading}
            {...otherProps}
            options={[
                ...(templates?.map((template) => {
                    const { id, name } = template;
                    return {
                        value: id,
                        key: id,
                        label: name,
                    };
                }) ?? []),
            ]}
        />
    );
};

export default React.memo(PurchasingLabelTemplateSelect);
